//test
export const getUser = state => {
    return state.user
}
export const gethisUser = state => {
  return state.hisuser
}
export const getPartList = state => {
  return state.partList
}

export const getBasepath = state =>{
  return state.basepath
}
export const getGood = state => {
  return state.good
}
export const getOrderGood = state => {
  return state.orderGood
}
export const getAddressList = state => {
  return state.addressList
}
export const getAddressId = state => {
  return state.addressId
}
export const getEditAddress = state => {
  return state.editAddress
}
export const getInsuranceOrderList = state => {
  return state.insuranceOrderList
}
export const getInsuarance = state => {
  return state.insuarance
}
export const getHBgoods = state => {
  return state.HBgoods
}

export const getItemMap = state => {
  return state.itemmap
}
export const getActivity = state => {
  return state.Activity
}
export const getEshopGood = state => {
  return state.eshopGood
}
export const getnItemMap = state => {
  return state.nitemmap
}
export const getOrderDetails = state => {
  return state.orderDetails
}
export const getCouponNum = state => {
  return state.CouponNum
}
export const getHealthItem = state => {
  return state.healthItem
}
export const getEshopUserInfo = state => {
  return state.eshopUserInfo
}
export const getSaveAnswer = state => {
  return state.saveAnswer
}
export const getCurrendIndex = state => {
  return state.currendIndex
}
export const getErrorExam = state => {
  return state.errorExam
}
export const getExamInfo = state => {
  return state.examInfo
}

export const getSaveAnswerp = state => {
  return state.saveAnswerp
}
export const getErrorExamp = state => {
  return state.errorExamp
}
export const getAllExamp = state => {
  return state.allExamp
}
export const getExamInfop = state => {
  return state.examInfop
}
export const getJobDetail = state => {
  return state.jobDetail
}
export const getMytoken = state => {
  return state.myToken
}
export const getExamType = state => {
  return state.examType
}
export const getSurveyInfo = state => {
  return state.surveyInfo
}
export const getSchoolist = state => {
  return state.schoollist
}
export const getMediaTeamUserList = state => {
  return state.mediaTeamUserList
}
export const getRd = state => {
  return state.rd
}
export const getPlayID = state => {
  return  state.playid
}
export const getCurrentPath = state => {
  return  state.currentPath
}
export const getTestResultText = state => {
  return  state.testResultText
}
export const getJdCategoryId = state => {
  return  state.jdCategoryId
}
export const getJdOptions = state => {
  return  state.jdOptions
}
export const getDjUser = state => {
  return  state.djUser
}
export const getShop = state => {
  return state.shop
}
